import type { DailyTrackState } from "@daily-co/daily-js";

export function getTrackUnavailableMessage(
  type: string,
  track: DailyTrackState,
) {
  if (!track) {
    return;
  }
  switch (track.state) {
    case "blocked":
      if (track.blocked?.byPermissions) {
        return `${type} permission denied`;
      }
      if (track.blocked?.byDeviceMissing) {
        return `${type} device missing`;
      }
      return `${type} blocked`;
    case "sendable":
      return `${type} not subscribed`;
    case "loading":
      return `${type} loading...`;
    case "interrupted":
      return `${type} interrupted`;
    default:
  }
}

export const getCopyForDailyError = (type: string) => {
  const fixIt = "refresh the page";

  // https://github.com/daily-co/daily-js/blob/daily-js-2024-09-26-0.72.0/src/shared-with-pluot-core/CommonIncludes.js#L58
  switch (type) {
    case "ejected":
      return {
        title: "Joined from another device",
        body: "Your call has closed due to being joined from another device.",
      };
    case "exp-room":
    case "exp-token":
      return {
        title: "Call has expired",
        body: "Your call exceeded its allotted time. Please start a new encounter to proceed.",
      };
    case "cam-in-use":
    case "mic-in-use":
    case "cam-mic-in-use":
      return {
        title: "Camera or microphone already in use",
        body: `We cannot access your camera or microphone. Close any apps (like Zoom or Teams) that might be using them, then ${fixIt}.`,
      };
    case "constraints":
    case "undefined-mediadevices":
    case "not-found":
      return {
        title: "Camera or microphone not detected",
        body: "We are unable to identify an audio or video input. Please try joining the call on another device.",
      };
    case "permissions":
      return {
        title: "Permission needed",
        permissions: true,
        body: `We need permission to access your camera or microphone. Please follow the steps below, then ${fixIt}.`,
      };
    default:
      return {
        title: "Unknown error",
        body: `We encountered an issue connecting to your camera or microphone. Please ${fixIt} and try again. If that fails, try joining the call on another device.`,
      };
  }
};
